// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"AdminUserManagement_tabContainer_3hoxB","buttonContainer":"AdminUserManagement_buttonContainer_1trfT","bulkInviteLink":"AdminUserManagement_bulkInviteLink_g2VrH"};